export enum EButtonColor {
	inherit = 'inherit',
	green = 'green',
	red = 'red',
	yellow = 'yellow',
	// Dark teal — maps to $branding-vemo `greenOne` in `_setting.scss`, same tone used by the
	// list-filters-panel search/clear buttons.
	teal = 'teal',
}

export type TTooltipPosition = 'left' | 'right' | 'above' | 'below'
